import { render, staticRenderFns } from "./hehuaCulture.vue?vue&type=template&id=74ac3d5b&scoped=true&"
import script from "./hehuaCulture.vue?vue&type=script&lang=js&"
export * from "./hehuaCulture.vue?vue&type=script&lang=js&"
import style0 from "./hehuaCulture.vue?vue&type=style&index=0&id=74ac3d5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac3d5b",
  null
  
)

export default component.exports